if ($('#header').length) {
    $('.navigation-buttons').append($('.languagesMenu').clone());
    $('.navigation-buttons').append($('button[data-target="login"]').clone());
}